"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailType = void 0;
var ThumbnailType;
(function (ThumbnailType) {
    ThumbnailType[ThumbnailType["Type1"] = 1] = "Type1";
    ThumbnailType[ThumbnailType["Type2"] = 2] = "Type2";
})(ThumbnailType || (exports.ThumbnailType = ThumbnailType = {}));
//# sourceMappingURL=thumbnail.js.map